export const ENTITY = {
  USER_ID: ':userId',
  PROJECT_ID: ':projectId',
  SOFTWARE_ID: ':softwareId',
  CLIENT_ID: ':clientId',
  SOFTWARE_VERSION_ID: ':versionId',
  WHITE_IP_ID: ':whiteIpId',
  VERSION_ID: ':versionId',
  PLATFORM_ID: ':platformId',
  PLATFORM_ALERT_ID: ':platformAlertId',
  SUBMODULE_ID: ':submoduleId',
  SOFTWARE_SETTINGS_ID: ':softwareSettingsId',
  IS_DEFAULT: ':default',
  SYSLOG_SETTING_ID: ':syslogSettingId',
  LICENSE_ID: ':licenseId',
  INSTANCE_ID: ':instanceId',
};

/**
* Maintaining all react local routes(urls)
*
* ##################### NOTE #########################
* This route declration is not applied at 'JSON' files
* ####################################################
*/
export const ROUTE = {
  ALL: '*',
  ROOT: '/',
  LOGIN: '/login',
  OTP: '/otp',
  FORGET_PASSWD: '/forgot-password',
  CHANGE_PASSWORD: '/reset-password',
  USER_CHANGE_PASSWORD: '/change-password',
  /** All User Related URL */
  USERS: '/users',
  USER_ADD: '/users/create',
  USER_EDIT: `/users/edit/${ENTITY.USER_ID}`,

  /** All Software and Submodule Related URL */
  SOFTWARE: '/software',
  SOFTWARES: '/softwares',
  SUBMODULE: '/submodule',
  SUBMODULES: '/submodules',
  SOFTWARE_VERSION: `/software/${ENTITY.SOFTWARE_ID}/versions`,
  SOFTWARE_DEFAULT_VERSION: `/software/${ENTITY.SOFTWARE_ID}/default-version`,
  SOFTWARE_SUBMODULE: `/software/${ENTITY.SOFTWARE_ID}/submodules`,
  SOFTWARE_SUBMODULE_VERSION: `/software/${ENTITY.SOFTWARE_ID}/submodule/${ENTITY.SUBMODULE_ID}/versions`,
  SOFTWARE_PLATFORMS: `/software/${ENTITY.SOFTWARE_ID}/platforms`,
  /** All Client Related URL */
  CLIENT: '/client',
  CLIENTS: '/clients',
  CLIENTS_VIEW: '/clients/:id',
  CLIENT_USERS: `/client/${ENTITY.CLIENT_ID}/users`,
  CLIENT_WHITE_IPS: `/client/${ENTITY.CLIENT_ID}/whitelisted-ips`,
  CLIENT_SOFTWARES: `/client/${ENTITY.CLIENT_ID}/softwares`,
  CLIENT_DOMAINS: `/client/${ENTITY.CLIENT_ID}/domains`,
  /** All Cloud Client Related URL */
  CLOUD_CLIENT: '/cloud-client',
  CLOUD_CLIENTS: '/cloud-clients',
  CLOUD_CLIENT_USERS: `/cloud-client/${ENTITY.CLIENT_ID}/users`,
  CLOUD_CLIENT_SOFTWARES: `/cloud-client/${ENTITY.CLIENT_ID}/softwares`,
  CLOUD_CLIENT_WHITE_LIST_IPS: `/cloud-client/${ENTITY.CLIENT_ID}/whitelist-ips`,
  CLOUD_CLIENT_DOMAINS: `/cloud-client/client/${ENTITY.CLIENT_ID}/domains`,

  /** All Re-Seller Related URL */
  RE_SELLER: '/re-seller',
  RE_SELLERS: '/re-sellers',
  RE_SELLER_CREATE: '/re-seller/create',

  /** All Platform Related URL  */
  PLATFORM: '/platform',
  PLATFORMS: '/platforms',
  PLATFORM_ALERT: '/platform-alert',
  PLATFORMS_ALERTS: '/platform-alerts',
  CRASH_LOGS: '/crash-logs',
  REQUEST_DEMO: '/request-demo',
  SYSTEM_EVENT: '/system-event',
  SYSTEM_EVENTS: '/system-events',
  SYSLOG_SETTING: '/syslog-setting',
  SYSLOG_SETTINGS: '/syslog-settings',
  ML_SCAN: '/ml-scan',
  ML_SCANS: '/ml-scans',
  INT_MODEL: '/intelligent-model',
  LICENSE_MANAGEMENT: '/license-management',
  LICENSE_INSTANCES: `/license/${ENTITY.LICENSE_ID}/instances`,
  LICENSE_SUB_INSTANCES: `/license/${ENTITY.INSTANCE_ID}/sub-instances`,
  LICENSE_TEMPLATES: '/license-management/templates',
  LICENSE_GENERATE: '/license-management/licenses',
  LICENSE_GENERATE_VIEW: '/license-management/licenses/:id',
  IP_FIREWALL: '/ip-firewall',
  IP_FIREWALLS: '/ip-firewalls',
  CLIENT_ADMIN_LICENSE_INSTANCES: `/software/${ENTITY.SOFTWARE_ID}/license-activations`,
  CLIENT_SOFTWARE_SUBMODULE_VERSION: `/software-submodule/${ENTITY.SUBMODULE_ID}/versions`,
  GENERAL_SETTINGS: '/system-settings/general',
};
